import { checkAuth } from '@/utils/helper';
import { arrToTree, treeToArr } from '@zenlayer/zen-design/esm/_util/utils';
import t from '@zenlayer/zen-intl18';
import { lazy } from 'react';

export const getMenus = () => {
  const menus: {
    name: string;
    permissions: boolean;
    children: {
      name: string;
      path: string;
      permissions: boolean;
    }[];
  }[] = [
    {
      name: t('gfABl1KhNCcQ'),
      permissions: checkAuth('menu:partner:getConfiguration'),
      children: [
        {
          name: t('ARICPkZDpKAF'),
          path: '/whiteLabel',
          permissions: checkAuth('menu:partner:getConfiguration'),
        },
      ],
    },
    {
      name: t('aLEf5UZ8RtrH'),
      permissions: checkAuth(
        'partner:endUserPage',
        'waveloa:list',
        'q:partner:pageInfo'
      ),
      children: [
        {
          name: t('i8ikKFCTEqda'),
          path: '/customer',
          permissions: checkAuth('partner:endUserPage'),
        },
        {
          name: t('qOdTLgfT8kRR'),
          path: '/loa',
          permissions: checkAuth('waveloa:list'),
        },
        {
          name: t('lQJeG8jMKYUn'),
          path: '/discountPage',
          permissions: checkAuth('q:partner:pageInfo'),
        },
        {
          name: t('bP2tymSIZg8c'),
          path: '/bgpAsn',
          permissions: checkAuth('p:bgp:pageInfo'),
        },
      ],
    },

    {
      name: t('xkGCDCQmMtdn'),
      permissions: checkAuth(
        'partner:billMonthByTeamUid',
        'partner:billByTeam',
        'partner:invoicePage'
      ),
      children: [
        {
          name: t('xZs7jfXbqQTD'),
          path: '/billing',
          permissions: checkAuth(
            'partner:billMonthByTeamUid',
            'partner:billByTeam'
          ),
        },
        {
          name: t('pHjB2tHRvvjx'),
          path: '/invoice',
          permissions: checkAuth('partner:invoicePage'),
        },
      ],
    },
    {
      name: t('IzKgde31b9Lx'),
      permissions: checkAuth('partner:operateLog', 'q:user:memberPageInfo'),
      children: [
        {
          name: t('qT8QBnbat6RB'),
          path: '/log',
          permissions: checkAuth('partner:operateLog'),
        },
        {
          name: t('84Xy2UzJjGXn'),
          path: '/member',
          permissions: checkAuth('q:user:memberPageInfo'),
        },
        {
          name: t('EdGxXm6zl97u'),
          path: '/operationNotice',
          permissions: checkAuth('partner:getOperateMailbox'),
        },
      ],
    },

    {
      name: t('drcFVlXCnCfW'),
      permissions: checkAuth('contract:partner:list'),
      children: [
        {
          name: t('7Ua8eUoJQJP8'),
          path: '/contract',
          permissions: checkAuth('contract:partner:list'),
        },
      ],
    },
  ];
  return arrToTree(
    treeToArr(menus, 'name').filter((i) => i.permissions),
    'name'
  );
};

export const router = [
  {
    path: '/dashboard',
    component: lazy(() => import('@/page/dashboard/index')),
    permissions: true,
  },
  {
    path: '/whiteLabel',
    component: lazy(() => import('@/page/whiteLabel')),
    permissions: checkAuth('menu:partner:getConfiguration'),
  },

  {
    path: '/customer',
    component: lazy(() => import('@/page/customer/list')),
    permissions: checkAuth('partner:endUserPage'),
  },
  {
    path: '/customerCreate',
    component: lazy(() => import('@/page/customer/create')),
    permissions: checkAuth('partnerEndUser:add'),
  },
  {
    path: '/billing',
    component: lazy(() => import('@/page/billing/list')),
    permissions: checkAuth('partner:billMonthByTeamUid', 'partner:billByTeam'),
  },
  {
    path: '/invoice',
    component: lazy(() => import('@/page/invoice/list')),
    permissions: checkAuth('partner:invoicePage'),
  },
  {
    path: '/billingDetail',
    component: lazy(() => import('@/page/billing/detail')),
    permissions: checkAuth('partner:billByTeam'),
  },
  {
    path: '/loa',
    component: lazy(() => import('@/page/loa/list')),
    permissions: checkAuth('waveloa:list'),
  },
  {
    path: '/discountPage',
    component: lazy(() => import('@/page/discount/list')),
    permissions: checkAuth('q:partner:pageInfo'),
  },
  {
    path: '/bgpAsn',
    component: lazy(() => import('@/page/bgpAsn/list')),
    permissions: checkAuth('p:bgp:pageInfo'),
  },
  {
    path: '/discountCreate',
    component: lazy(() => import('@/page/discount/create/index')),
    permissions: checkAuth('q:partner:save'),
  },
  {
    path: '/log',
    component: lazy(() => import('@/page/log/list')),
    permissions: checkAuth('partner:operateLog'),
  },
  {
    path: '/member/create',
    component: lazy(() => import('@/page/member/create')),
    permissions: checkAuth('q:user:addMember'),
  },
  {
    path: '/member',
    component: lazy(() => import('@/page/member/list')),
    permissions: checkAuth('q:user:memberPageInfo'),
  },
  {
    path: '/operationNotice',
    component: lazy(() => import('@/page/operationNotice/list')),
    permissions: checkAuth('partner:getOperateMailbox'),
  },
  {
    path: '/contract',
    component: lazy(() => import('@/page/contract/list')),
    permissions: checkAuth('contract:partner:list'),
  },
  {
    path: '/contract/create/:contractType',
    component: lazy(() => import('@/page/contract/create')),
    permissions: checkAuth('contract:partner:create'),
  },
];
